import {Outlet} from "react-router-dom";

export const ResultLayout = () => {
    return <>
        <div
            className="bg-[url(/img/bg-m.jpg)] md:bg-[url(/img/bg.jpg)] bg-cover bg-center min-h-screen relative flex flex-col items-center !justify-center md:justify-start overflow-y-auto overflow-x-hidden">
            {/*<div*/}
            {/*    className="flex justify-center items-center mx-auto w-full h-52 max-w-[35rem] mt-[-5rem] md:max-w-[50rem] md:mt-[-12rem]">*/}
            {/*    <div className="absolute top-[30px] max-w-[1100px] w-full flex justify-end mr-4">*/}
            {/*        <button*/}
            {/*            onClick={handleSkip}*/}
            {/*            className="font-inter text-[16px] font-bold leading-[34px] tracking-[0.48px] uppercase flex gap-4 justify-end items-center no-underline after:w-4 after:h-4 after:bg-[url('data:image/svg+xml,%3Csvg xmlns=...')] after:bg-no-repeat after:bg-contain quiz-skip-text">*/}
            {/*            Pomiń <Icon icon="arrowRight" className="w-6 h-6"/>*/}
            {/*        </button>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <div className="relative z-10">
                <Outlet/>
            </div>
        </div>
    </>
}